import React from 'react';

import { Glyph } from './WebsiteGlyph.styles';

/**
 * "Website" nav glyph: a bookmark with a star (Material Symbols `bookmark_star`, filled, weight 400),
 * for the section that groups what the owner shows on their casino site (Website Creatives, Game Lists,
 * Blog). Drawn inline (not via `<img>`) with `fill="currentColor"` on the path so the nav's active/hover
 * `path[fill]` rule can recolour it, like the Players / Marketing glyphs; the idle colour comes from the
 * nav-icon token on the `Glyph` wrapper.
 */
export type WebsiteGlyphProps = {
  size?: number;
  className?: string;
};

export const WebsiteGlyph = ({ size = 24, className }: WebsiteGlyphProps): React.ReactElement => (
  <Glyph className={className} aria-hidden="true">
    <svg width={size} height={size} viewBox="0 -960 960 960" fill="none">
      <path
        fill="currentColor"
        d="m389-400 91-55 91 55-24-104 80-69-105-9-42-98-42 98-105 9 80 69-24 104ZM200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z"
      />
    </svg>
  </Glyph>
);

export default WebsiteGlyph;
